import { useSelector } from "react-redux";
import LinkWrap from "../../../../components/LinkWrap/component";
import {
    SPONSOR_LABEL,
    TITLE_VERBIAGE,
    TRANSPARENCY_LINK,
} from "../../../../utils/sponsor/constants";
import "./styles/themes/_default.scss";

const liveLabels = ["live", "live blog", "live chat", "coming up"];
const sponsoredLabels = ["sponsored content", "sponsor content"];

export const createSecondLabel = (label, showDot = true) => {
    const lowerCaseLabel = label.toLowerCase();
    const isLive = liveLabels.includes(lowerCaseLabel);
    const isBreaking = lowerCaseLabel === "breaking";

    return (
        <span>
            {showDot && <span>&middot;</span>}
            <span data-live={`${isLive}`} data-breaking={`${isBreaking}`}>
                {label}
            </span>
        </span>
    );
};

const LinkLabel = ({ label, departments, insideBreadcrumbs }) => {
    if (typeof label !== "string") label = "";
    if (!Array.isArray(departments)) departments = [];

    const isSponsored = sponsoredLabels.includes(label.toLowerCase());
    const [department = {}] = departments.slice(-1);
    const sectionPath = useSelector((state) => state.app.section);
    const link = isSponsored ? TRANSPARENCY_LINK : `/${sectionPath}`;

    const departmentLabel = department.name || "";

    let secondLabel = null;
    if (
        label &&
        !isSponsored &&
        departmentLabel.toLowerCase() !== label.toLowerCase()
    ) {
        secondLabel = createSecondLabel(label, !insideBreadcrumbs);
    }
    return (
        <span
            className="detail-link-label sclt-storySectionLink"
            data-testid="detail-link-label"
        >
            {isSponsored ? (
                <a href={TRANSPARENCY_LINK} title={TITLE_VERBIAGE}>
                    <span className="sponsored-content">{SPONSOR_LABEL}</span>
                </a>
            ) : null}

            {!insideBreadcrumbs && (
                <LinkWrap url={link} external={isSponsored}>
                    <span title={isSponsored ? TITLE_VERBIAGE : null}>
                        {isSponsored ? SPONSOR_LABEL : departmentLabel}
                    </span>
                </LinkWrap>
            )}
            {secondLabel}
        </span>
    );
};

export default LinkLabel;
